import React from "react";
import ControlSection from "./ControlSection";
import NumberInput from "./NumberInput";

// Helper function to convert negative x/y values to 0 for display only
const getDisplayValue = (value) => {
  if (value === "" || value === null || value === undefined) return value;
  const num = parseFloat(value);
  if (isNaN(num)) return value;
  return num < 0 ? "0" : value;
};

/**
 * Position controls component for X and Y coordinates
 */
const PositionControls = ({
  xValue,
  yValue,
  minX,
  maxX,
  minY,
  maxY,
  onXChange,
  onYChange,
  onXBlur,
  onYBlur,
  onXKeyDown,
  onYKeyDown,
}) => {
  return (
    <ControlSection>
      <div
        style={{
          display: "flex",
          gap: "16px",
          alignItems: "center",
        }}
      >
        <NumberInput
          label="XPos"
          value={getDisplayValue(xValue)}
          min={minX}
          max={maxX}
          onChange={onXChange}
          onBlur={onXBlur}
          onKeyDown={onXKeyDown}
        />
        <NumberInput
          label="YPos"
          value={getDisplayValue(yValue)}
          min={minY}
          max={maxY}
          onChange={onYChange}
          onBlur={onYBlur}
          onKeyDown={onYKeyDown}
        />
      </div>
    </ControlSection>
  );
};

export default PositionControls;
